(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      const select = section.querySelector('[data-variant-select]');
      const script = section.querySelector('[data-variants]');
      if (!select || !script) return;
      let variants;
      try { variants = JSON.parse(script.textContent); } catch { return; }
      if (!Array.isArray(variants) || !variants.length) return;
      section.dataset.initialized = 'true';
      const options = section.querySelector('.variant-options');
      const form = section.querySelector('.product-form');
      const add = section.querySelector('[data-add-button]');
      const price = section.querySelector('[data-price]');
      const compare = section.querySelector('[data-compare]');
      const image = section.querySelector('.main-product-image');
      const initialImage = image ? {src: image.src, srcset: image.srcset, alt: image.alt} : null;
      const status = section.querySelector('[data-variant-status]');
      const currency = section.dataset.currency || 'EUR';
      const money = value => new Intl.NumberFormat(section.dataset.locale || 'it', {style: 'currency', currency}).format(value / 100);
      let current = variants.find(v => String(v.id) === select.value) || variants[0];
      const fieldsets = [...options.querySelectorAll('fieldset')];
      const syncRadios = () => fieldsets.forEach((field, i) => field.querySelectorAll('input').forEach(input => input.checked = input.value === current.options[i]));
      syncRadios();
      options.hidden = false;
      section.querySelector('.variant-fallback').hidden = true;
      const render = variant => {
        current = variant;
        select.value = variant ? String(variant.id) : '';
        add.disabled = !variant || !variant.available;
        add.textContent = !variant ? section.dataset.unavailable : (variant.available ? section.dataset.add : section.dataset.soldOut);
        status.textContent = !variant ? section.dataset.unavailable : (variant.available ? '' : section.dataset.soldOut);
        if (variant) {
          price.textContent = money(variant.price);
          compare.hidden = !(variant.compare_at_price > variant.price);
          compare.textContent = variant.compare_at_price ? money(variant.compare_at_price) : '';
          const quantity = form.querySelector('[name="quantity"]');
          const rule = variant.quantity_rule || {min:1,increment:1};
          quantity.min = rule.min || 1; quantity.step = rule.increment || 1;
          if (rule.max) quantity.max = rule.max; else quantity.removeAttribute('max');
          quantity.value = rule.min || 1;
          if (image && variant.featured_image && variant.featured_image.src) {
            image.removeAttribute('srcset'); image.src = variant.featured_image.src;
            image.alt = variant.featured_image.alt || initialImage.alt;
          } else if (image && initialImage) {
            image.src = initialImage.src; image.srcset = initialImage.srcset; image.alt = initialImage.alt;
          }
          const url = new URL(location.href); url.searchParams.set('variant',variant.id); history.replaceState({},'',url);
        }
        const chosen = fieldsets.map(field => field.querySelector('input:checked')?.value);
        fieldsets.forEach((field,i) => field.querySelectorAll('input').forEach(input => {
          const possible = chosen.map((value,j) => j === i ? input.value : value);
          const available = variants.some(v => v.available && possible.every((value,j) => value === v.options[j]));
          input.closest('label').classList.toggle('is-unavailable',!available);
        }));
      };
      render(current);
      options.addEventListener('change',() => {
        const chosen = fieldsets.map(field => field.querySelector('input:checked')?.value);
        render(variants.find(v => chosen.every((value,i) => value === v.options[i])));
      });
      select.addEventListener('change',() => {
        current = variants.find(v => String(v.id) === select.value);
        if (current) { syncRadios(); render(current); }
      });
      form.addEventListener('submit',event => {if (!current || !current.available) event.preventDefault();});
      section.querySelectorAll('[data-image-src]').forEach(link => link.addEventListener('click',event => {
        if (!image) return;
        event.preventDefault(); image.removeAttribute('srcset'); image.src=link.dataset.imageSrc;
        image.alt=link.querySelector('img')?.alt || initialImage.alt;
        section.querySelectorAll('[data-image-src]').forEach(item=>item.removeAttribute('aria-current'));
        link.setAttribute('aria-current','true');
      }));
    });
  };
  init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.mobile-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
  document.addEventListener('click',event=>document.querySelectorAll('.mobile-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;}));
})();
